import CatalogEditor from './CatalogEditor';

export default function EditOffer() { return <CatalogEditor kind="offer" editing />; }
